import { useState, useEffect } from 'react';
import { CATALOGO } from '@/constants/catalogo';

export default function CfgShowroom({ producto, onUpdate }) {
  const fases = CATALOGO.showroomSoftware.fases;
  const [cfg, setCfg] = useState(
    producto.config?.items ||
      Object.fromEntries(
        Object.keys(fases).map((k) => [k, { incluido: true, precio: fases[k].precio }])
      )
  );

  const recalc = (newCfg) => {
    const total = Object.values(newCfg).reduce(
      (s, item) => s + (item.incluido ? item.precio : 0),
      0
    );
    setCfg(newCfg);
    onUpdate({ config: { items: newCfg }, precioFinal: total });
  };

  useEffect(() => {
    if (!producto.configurado) recalc(cfg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-2">
      {Object.entries(fases).map(([key, fase]) => (
        <div
          key={key}
          className={`p-3 rounded-lg border ${
            cfg[key]?.incluido
              ? 'border-brand-gold/50 bg-brand-gold/5'
              : 'border-neutral-800 bg-neutral-900/50'
          }`}
        >
          <div className="flex items-center justify-between gap-3">
            <label className="flex items-center gap-3 cursor-pointer flex-1">
              <input
                type="checkbox"
                checked={cfg[key]?.incluido || false}
                onChange={(e) =>
                  recalc({ ...cfg, [key]: { ...cfg[key], incluido: e.target.checked } })
                }
                className="accent-brand-gold"
              />
              <span className="text-white text-sm">{fase.label}</span>
            </label>
            <input
              type="number"
              value={cfg[key]?.precio || 0}
              onChange={(e) =>
                recalc({
                  ...cfg,
                  [key]: { ...cfg[key], precio: parseFloat(e.target.value) || 0 },
                })
              }
              className="w-36 px-2 py-1 bg-neutral-900 border border-neutral-800 rounded text-xs text-white text-right focus:outline-none focus:border-brand-gold/50"
            />
          </div>
        </div>
      ))}
      <div className="text-[10px] text-neutral-500 pt-2">
        Incluye implementación, capacitación y licencia 3 años
      </div>
    </div>
  );
}
